module.exports = __webpack_public_path__ + "static/img/1-2.3c56672.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/1-2.png
// module id = UVjm
// module chunks = 0